import React from 'react';
import Home from './components/pagehome';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Nav from './components/navbar.jsx';
import Rooms from './components/pageRooms'; 
import RestaurantPage  from './components/pageRestaurant';
import NotreHotel from './components/notreHotel';
import ContactPage from './components/pageContact.jsx';
import ExcursionDetail from './components/pageExcursionDetail';
export default function App() {
  return (
    <Router>
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/riad-lina" element={<Rooms />} />
        <Route path="/restaurant" element={<RestaurantPage />} />
        <Route path="/galerie" element={<NotreHotel />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/excursions/:excursionId" element={<ExcursionDetail />} />
      </Routes>
    </Router>
  );
}

